import React, { Component } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Badge, Button, Alert, Spinner} from 'reactstrap';
import greencheck from '../../images/greencheck.png'
import BackButton from '../BackButton';

export default class Application extends Component {
    constructor(props) {
        super(props);

        this.state = {
            boards: [],
            fieldValues: {},
            submitted: false,
            submitError: false,
            backgroundCheck: false,
            isSubmitting: false
        };
    }

    componentDidMount() {
        fetch('/api/boards?isActive=true', {
            method: 'GET'
        })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ boards: data });
            })

        fetch('api/login?token=' + sessionStorage.getItem("token"), {
            method: 'GET'
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        if (!data.googleId) {
                            alert('Google sign in could not complete authentication.  Please sign in to authenticate.');
                            this.props.history.push('/signin');
                        } else {
                            this.props.history.push('/application/' + data.googleId);
                            this.setState({ googleId: data.googleId });
                        }
                    })
                } else {
                    alert('There was an error in the sign in process.  Please try again at a later time.');
                }
            })   
    }

    editProfile = () => {
        var toLeave = window.confirm("Are you sure you would like to leave this page and view your profile?");
        if (toLeave) {
            this.props.history.push('/profile/' + this.state.googleId);
        }
    }

    handleChange = (e) => {
        if (e.target.type === "file") {
            let files = e.target.files;
            for (var i = 0; i < files.length; i++) {
                //check file size
                if (files[i].size > process.env.REACT_APP_FILESIZELIMIT) {
                    alert('File size cannot exceed 2mb');
                    e.target.value = "";
                    return;
                }
                //check extension
                let ext = files[i].name.match(/.([^.]+)$/)[1];
                if (ext !== 'pdf') {
                    alert('Please choose a pdf file');
                    e.target.value = "";
                    return;
                }
            }
        }

        let fieldValues = this.state.fieldValues;
        fieldValues[e.target.name] = e.target.type === "checkbox" ? e.target.checked : e.target.type === "file" ? e.target.files : e.target.value;
        if (e.target.type === "file") {
            let originalFiles = fieldValues[e.target.name];
            let renamedFiles = [];
            for (var i = 0; i < originalFiles.length; i++) {
                let renamedFile = new File([originalFiles[i]], e.target.name + "_" + originalFiles[i].name, { type: originalFiles[i].type });
                renamedFiles[i] = renamedFile;
            }
            fieldValues[e.target.name] = renamedFiles;
        }       
        this.setState({ fieldValues: fieldValues })  
    }

    handleBoardChange = (e) => {
        var boardId = e.target.value;
        fetch('/api/boards/' + boardId, {
            method: 'GET'
        })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ backgroundCheck: data.backgroundCheck })
            })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        fetch('api/login?token=' + sessionStorage.getItem("token"), {
            method: 'GET'
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        if (!data.googleId) {
                            alert('Google sign in could not complete authentication.  Please sign in to authenticate.');
                            this.props.history.push('/signin');
                        } else {
                            // authenticated
                            this.setState({ googleId: data.googleId });
                            this.setState({ isSubmitting: true });

                            let body = JSON.stringify({
                                boardId: this.state.fieldValues.boardId,
                                googleId: data.googleId
                            })

                            let formData = new FormData();
                            if (this.state.fieldValues.fileUploadResume !== undefined) {
                                for (var i = 0; i < this.state.fieldValues.fileUploadResume.length; i++) {
                                    formData.append('file[]', this.state.fieldValues.fileUploadResume[i]);
                                }
                            }
                            if (this.state.fieldValues.fileUploadBCheck !== undefined) {
                                for (var i = 0; i < this.state.fieldValues.fileUploadBCheck.length; i++) {
                                    formData.append('file[]', this.state.fieldValues.fileUploadBCheck[i]);
                                }
                            }
                            formData.append('data', body);

                            fetch('api/applications', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json'
                                },
                                body: formData
                            })
                                .then(response => {
                                    this.setState({ submitted: true, isSubmitting: false })
                                    if (response.ok) {
                                        this.setState({ submitError: false })
                                    } else {
                                        response.json().then(data => {
                                            this.setState({ submitError: true, alertMessage: data })
                                        })
                                    }
                                })   

                        }
                    })
                } else {
                    alert('There was an error in the sign in process.  Please try again at a later time.');
                }
            })         
    }

    goToUserApplications = () => {
        this.props.history.push('/applicationlist/' + this.state.googleId);
    }

    goBackToDashboard = () => {
        this.props.history.push('/dashboard/' + this.state.googleId);
    }

    render() {
        return (   
            <div>                
                <Container className="form-border">
                    <Row>
                        <Col sm="12">
                            <BackButton navTitle="Dashboard" onClickBack={this.goBackToDashboard} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <div
                                className="rounded px-3 px-sm-4 py-3 py-sm-5 text-center"
                                style={{ backgroundColor: "#e9ecef" }}
                            >
                                <h1>St. Louis County</h1>
                                <hr />
                                <h4>Apply for a Board or Commission</h4>
                            </div>
                        </Col>
                    </Row>
                    {this.state.submitError &&
                        <Alert color="danger">
                            <h4 className="alert-heading">Submission Error</h4>
                            <hr />
                            {this.state.alertMessage}
                        </Alert>
                    }
                    {(!this.state.submitted || this.state.submitError) &&
                        <Form id="application" onSubmit={this.handleSubmit}>
                            <Row>
                                <Col sm="12">                                    
                                    <div className="form-border my-4">
                                        <Label for="submitProfileSwitch" className="lead">Your profile will be submitted with your application.</Label>
                                        <FormGroup switch>
                                            <Input
                                                type="switch"
                                                role="switch"
                                                id="submitProfileSwitch"
                                                name="submitProfileSwitch"
                                                required
                                                onChange={this.handleChange} value={this.state.fieldValues.submitProfileSwitch}
                                            />
                                            <Label for="submitProfileSwitch">
                                                I confirm my profile is accurate and agree to submit my profile with application.
                                            </Label>
                                        </FormGroup>
                                        <Badge color="secondary" onClick={this.editProfile} className="badge">View / Edit Profile</Badge>                                        
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label>Please choose a Board or Commission</Label>
                                        <Input type="select" name="boardId" required value={this.state.fieldValues.boardId} onChange={(e) => { this.handleChange(e); this.handleBoardChange(e) }}>
                                            <option value=''></option>
                                            {this.state.boards.length > 0 &&
                                                this.state.boards.map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.id}>{item.name}</option>
                                                    )
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <FormGroup className="form-border">
                                        <Label>Please upload your resume as a pdf document.</Label>
                                        <Input type="file" name="fileUploadResume" onChange={this.handleChange} multiple required accept=".pdf" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            {this.state.backgroundCheck &&
                                <Row>
                                    <Col sm="12">
                                        <FormGroup className="form-border">
                                    <Label>Your chosen board requires additional documents.  Please obtain a background check from the <a target="_blank" rel="noopener noreferrer" href='https://www.machs.mo.gov/MocchWebInterface/pidSearch.html'>Missouri State Highway Patrol</a> and upload it as a pdf document.</Label>
                                            <Input type="file" name="fileUploadBCheck" onChange={this.handleChange} multiple required accept=".pdf"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col sm="12">
                                    <FormGroup switch className="pb-4">
                                        <Input 
                                            type="switch" 
                                            role="switch"
                                            id="agreementSwitch"
                                            name="agreementSwitch"
                                            required                                                
                                        />
                                        <Label for="agreementSwitch">
                                            I attest that I understand that this document is a public record.
                                            In certain circumstances this application may be considered an open record subject to disclosure upon request.
                                            If you assert a privacy interest in any information or record that you provide during the application process,
                                            such assertion will be considered by St. Louis County in its determination of whether the information or record
                                            is open and subject to discloser. Your assertion of a privacy interest must be received by St. Louis County
                                            prior to any request for disclosure. St. Louis County makes no guarantee that this record or any information
                                            received in your application process will be considered closed unless otherwise mandated by law.
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <Button type="submit" id={this.props.id} color="primary" disabled={this.state.isSubmitting}>Apply to Board</Button>
                                    {this.state.isSubmitting && <span><Alert color="secondary"><Spinner size="sm" color="dark" /> Submitting Your Application...</Alert></span>}
                                </Col>
                            </Row>
                        </Form>
                    }                           
                    {this.state.submitted && !this.state.submitError &&
                        <Container>
                            <Row className="justify-content-center">
                                <Col className="col-12 text-center">
                                    <img src={greencheck} alt="success" height="50" width="50" />
                                </Col>
                            </Row>
                            <br />
                            <Row className="justify-content-center">
                                <Col className="col-12 text-center">
                                    <p className="font-weight-bold">Success!</p>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col className="col-12 text-center">
                                    <p>Your application has been succesfully submitted</p>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col className="col-12 text-center">
                                    <p className="font-weight-bold">Click on the button below to view your applications and status</p>
                                    <Button id="goToUserApplications" color="primary" onClick={this.goToUserApplications}>Go To Applications</Button>
                                </Col>
                            </Row>
                        </Container>
                    }
                </Container>     
            </div>
        )
    }
}